var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "select", attrs: { id: _vm.id } }, [
    _c(
      "div",
      {
        staticClass: "mdc-select mdc-select--outlined",
        class: {
          "mdc-select--invalid": !_vm.pristine && !_vm.valid,
          "mdc-select--valid": !_vm.pristine && _vm.valid
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "mdc-select__anchor select--fullwidth",
            style: _vm.style
          },
          [
            _c("span", { staticClass: "mdc-select__selected-text-container" }, [
              _c("span", {
                staticClass: "mdc-select__selected-text ",
                style: _vm.style,
                attrs: { id: _vm.selectedTextId }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "mdc-select__dropdown-icon" }, [
              _c(
                "svg",
                {
                  staticClass: "mdc-select__dropdown-icon-graphic",
                  attrs: { viewBox: "7 10 10 5", focusable: "false" }
                },
                [
                  _c("polygon", {
                    staticClass: "mdc-select__dropdown-icon-inactive",
                    attrs: {
                      stroke: "none",
                      "fill-rule": "evenodd",
                      points: "7 10 12 15 17 10"
                    }
                  }),
                  _vm._v(" "),
                  _c("polygon", {
                    staticClass: "mdc-select__dropdown-icon-active",
                    attrs: {
                      stroke: "none",
                      "fill-rule": "evenodd",
                      points: "7 15 12 10 17 15"
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("bk-outline-notched", {
              attrs: { label: _vm.label, id: _vm.id }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "mdc-select__menu mdc-menu mdc-menu-surface select__menu",
            style: _vm.style
          },
          [
            _c(
              "ul",
              {
                staticClass: "mdc-list",
                class: {
                  "mdc-select__menu--max-height":
                    _vm.items.length > _vm.maxNumberOfItemsShown
                }
              },
              _vm._l(_vm.items, function(item) {
                return _c(
                  "li",
                  {
                    staticClass: "mdc-list-item",
                    class: {
                      "mdc-list-item--selected": item.value === _vm.value
                    },
                    attrs: { "data-value": item.value, role: "option" }
                  },
                  [
                    _c("span", { staticClass: "mdc-list-item__ripple" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "mdc-list-item__text" }, [
                      _vm._v(_vm._s(item.name))
                    ])
                  ]
                )
              }),
              0
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }